import { createFileRoute } from '@tanstack/react-router';
import { SuppliersPage } from '@/features/suppliers/components/SuppliersPage';

export const Route = createFileRoute('/$commiteeSlug/suppliers/')({
  component: SuppliersPage,
});
